import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { READABLE_BODY_SX, READABLE_TITLE_SX } from "src-next/modules/clinical-insights/constants/clinicalInsightsTheme";
import type { ClinicalPractitionerEntry } from "src-next/modules/clinical-insights/types/analysisTypes";

interface ClinicalPractitionerSelectProps {
  practitionerId: string;
  onPractitionerChange: (value: string) => void;
  practitioner?: ClinicalPractitionerEntry[];
  fullWidth?: boolean;
  /** false quando o rótulo “Profissional” é renderizado fora (painel esquerdo). */
  showFloatingLabel?: boolean;
}

function formatPractitionerLabel(entry: ClinicalPractitionerEntry): string {
  const name = entry.resource?.name?.[0];
  const text = name?.text?.trim();
  if (text) return text;
  const given = name?.given?.join(" ") ?? "";
  const family = name?.family ?? "";
  return `${given} ${family}`.trim() || entry.resource?.id || "Profissional";
}

const formControlSx = {
  minWidth: 220,
  "& .MuiInputLabel-root": {
    ...READABLE_TITLE_SX,
    fontWeight: 700,
  },
  "& .MuiInputBase-input": {
    ...READABLE_BODY_SX,
  },
  "& .MuiSelect-select": {
    ...READABLE_BODY_SX,
  },
} as const;

export function ClinicalPractitionerSelect({
  practitionerId,
  onPractitionerChange,
  practitioner,
  fullWidth = false,
  showFloatingLabel = true,
}: ClinicalPractitionerSelectProps) {
  const labelId = "clinical-insights-practitioner-label";

  return (
    <FormControl
      size="medium"
      fullWidth={fullWidth}
      sx={{ ...formControlSx, minWidth: fullWidth ? undefined : 220 }}
    >
      {showFloatingLabel ? (
        <InputLabel id={labelId}>Profissional</InputLabel>
      ) : null}
      <Select
        labelId={labelId}
        id="clinical-insights-practitioner"
        label={showFloatingLabel ? "Profissional" : undefined}
        displayEmpty={!showFloatingLabel}
        value={practitionerId === "all" ? "" : practitionerId}
        onChange={(e) => onPractitionerChange(e.target.value)}
      >
        <MenuItem value="">Todos</MenuItem>
        {(practitioner ?? []).map((entry) => {
          const id = entry.resource?.id;
          if (!id) return null;
          return (
            <MenuItem key={id} value={id}>
              {formatPractitionerLabel(entry)}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
